import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Cadastro() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ nome: '', email: '', whatsapp: '', senha: '', confirma: '', termos: false, privacidade: false });
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const upd = e => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: v }));
  };

  const submit = async e => {
    e.preventDefault(); setErro('');
    if (form.senha !== form.confirma) return setErro('As senhas não coincidem.');
    if (!form.termos || !form.privacidade) return setErro('Aceite os termos e a política de privacidade.');
    setLoading(true);
    try {
      await api.post('/auth/cadastro', { nome: form.nome, email: form.email, whatsapp: form.whatsapp, senha: form.senha });
      await login(form.email, form.senha);
      nav('/planos');
    } catch (err) { setErro(err.response?.data?.error || 'Erro ao criar conta.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--ink)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 24px' }}>
      <div style={{ width: '100%', maxWidth: 460 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32, justifyContent: 'center' }}>
          <img src="/assets/heritage-logo-transparent.png" alt="Heritage" style={{ width: 48, height: 48, objectFit: 'contain' }} />
          <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: '#fff', fontWeight: 700 }}>Heritage BH</span>
        </Link>

        <div style={{ background: '#fff', borderRadius: 'var(--r-md)', padding: '36px 40px', boxShadow: 'var(--shadow-lg)' }}>
          <div style={{ marginBottom: 24 }}>
            <div className="eyebrow">Cadastro</div>
            <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 600 }}>Criar minha conta</h1>
            <p style={{ fontSize: 13, color: 'var(--ink-muted)', marginTop: 8 }}>7 dias gratuitos. Cancele quando quiser, sem custo durante o período de teste.</p>
          </div>

          {erro && <div className="alert alert-danger">{erro}</div>}

          <form onSubmit={submit}>
            <div className="form-group"><label>Nome completo</label><input name="nome" value={form.nome} onChange={upd} required /></div>
            <div className="form-group"><label>E-mail</label><input name="email" type="email" value={form.email} onChange={upd} required /></div>
            <div className="form-group"><label>WhatsApp</label><input name="whatsapp" value={form.whatsapp} onChange={upd} placeholder="(11) 99999-9999" /></div>
            <div className="form-group"><label>Senha</label><input name="senha" type="password" value={form.senha} onChange={upd} required minLength={6} /></div>
            <div className="form-group"><label>Confirmar senha</label><input name="confirma" type="password" value={form.confirma} onChange={upd} required /></div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, margin: '18px 0 24px' }}>
              <label className="checkbox-group"><input type="checkbox" name="termos" checked={form.termos} onChange={upd} /><span style={{ fontSize: 13 }}>Aceito os <Link to="/termos" style={{ color: 'var(--rust)' }}>Termos de uso</Link></span></label>
              <label className="checkbox-group"><input type="checkbox" name="privacidade" checked={form.privacidade} onChange={upd} /><span style={{ fontSize: 13 }}>Aceito a <Link to="/privacidade" style={{ color: 'var(--rust)' }}>Política de privacidade</Link></span></label>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', minHeight: 50 }} disabled={loading}>
              {loading ? 'Criando conta…' : 'Criar conta e começar'}
            </button>
          </form>

          <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--ink-muted)', marginTop: 22 }}>
            Já tem conta?{' '}
            <Link to="/login" style={{ color: 'var(--rust)', fontWeight: 900 }}>Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
